import React from "react";
import { waLink, WHATSAPP_GREEN } from "@/config/brand";

/**
 * Floating WhatsApp button — fixed to the bottom-right on every public page.
 * Always visible. Subtle pulse ring + hover scale. Opens WhatsApp with the
 * standard pre-filled enquiry message.
 */
export const FloatingWhatsApp = () => (
    <a
        data-testid="floating-whatsapp-button"
        href={waLink()}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat with YS Removals on WhatsApp"
        className="fixed z-40 right-4 md:right-6 bottom-24 md:bottom-6 group"
        style={{ marginBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
        <span className="relative inline-flex">
            <span
                aria-hidden="true"
                className="absolute inset-0 rounded-full opacity-60 animate-ping"
                style={{ backgroundColor: WHATSAPP_GREEN }}
            />
            <span
                className="relative inline-flex h-14 w-14 items-center justify-center rounded-full text-white shadow-[0_10px_30px_rgba(37,211,102,0.45)] transition-transform duration-200 group-hover:scale-110 group-active:scale-95"
                style={{ backgroundColor: WHATSAPP_GREEN }}
            >
                {/* Official WhatsApp glyph */}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    className="h-7 w-7"
                    fill="currentColor"
                    aria-hidden="true"
                >
                    <path d="M19.11 17.24c-.3-.15-1.77-.87-2.05-.97-.28-.1-.48-.15-.68.15-.2.3-.78.97-.95 1.17-.18.2-.35.22-.65.08-.3-.15-1.27-.47-2.41-1.49-.89-.8-1.49-1.78-1.67-2.08-.18-.3-.02-.46.13-.61.13-.13.3-.35.45-.53.15-.18.2-.3.3-.5.1-.2.05-.38-.02-.53-.08-.15-.68-1.63-.93-2.24-.24-.58-.49-.5-.68-.51-.18-.01-.38-.01-.58-.01-.2 0-.53.08-.81.38s-1.06 1.03-1.06 2.52 1.09 2.92 1.24 3.12c.15.2 2.14 3.27 5.19 4.59.73.31 1.29.5 1.73.64.73.23 1.39.2 1.91.12.58-.09 1.77-.72 2.02-1.42.25-.7.25-1.29.18-1.42-.07-.13-.28-.2-.58-.35zM16.02 5.33c-5.86 0-10.62 4.76-10.62 10.62 0 1.88.5 3.72 1.44 5.34l-1.52 5.53 5.66-1.48c1.55.84 3.3 1.29 5.03 1.29 5.86 0 10.62-4.76 10.62-10.62 0-2.83-1.1-5.5-3.1-7.5-2-2-4.67-3.18-7.51-3.18z" />
                </svg>
            </span>
        </span>
        <span className="sr-only">Chat on WhatsApp</span>
    </a>
);
